import { format } from 'date-fns';

const methods = {};

export const currency = (amount, symbol = '$') => `${symbol} ${amount}` || `${symbol} 0.00`;

export const round = (value, decimals = 2) => {
	if (value && typeof value === 'number') {
		return value.toFixed(decimals);
	}
	if (typeof value === 'undefined' || value === null) {
		return '0.00';
	} else if (typeof value === 'string') {
		return value;
	}
	return '0.00';
};

export const parseDate = (date, option = 'DD/MM/YYYY') => {
	if (date) {
		return format(date, option);
	}
	return null;
};

export const truncate = (string, length = 22) => {
	if (string.length <= length) {
		return string;
	}
	return `${string.substring(0, length)}...`;
};

export default methods;



// WEBPACK FOOTER //
// ./src/shared/filters.js